import JSZip from 'jszip'

export const downloadFile = (link) => {
  fetch(link, {
    method: 'GET',
    headers: {},
  })
    .then((response) => {
      response.arrayBuffer().then(function (buffer) {
        const extension = response?.url?.split('.')[response?.url?.split('.').length - 1] || 'png'

        const url = window.URL.createObjectURL(new Blob([buffer]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `media.${extension}`) //or any other extension
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const downloadFilesAsZip = async (urls, setDownloading = null) => {
  const zip = new JSZip()

  if (urls?.length > 0) {
    setDownloading && setDownloading(true)

    for (let i = 0; i < urls.length; i++) {
      const response = await fetch(urls[i])
      const blob = await response.blob()
      zip.file(urls[i].split('/').pop(), blob)
    }

    const zipData = await zip.generateAsync({
      type: 'blob',
      streamFiles: true,
    })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(zipData)
    link.download = 'Results.zip'
    link.click()

    setDownloading && setDownloading(false)
  }
}

export const dataURIToBlob = (dataURI) => {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}

export const convertUrlToFile = async (url, type, callback) => {
  try {
    const response = await fetch(url, { mode: 'cors' })
    const extension = url.split('.').pop() || 'png'
    const fileName = `${type}.${extension}`
    const blob = await response.blob()
    const file = new File([blob], fileName, { type: blob.type })
    callback(file)
  } catch (err) {
    console.error(err)
  }
}
